import { render, staticRenderFns } from "./BudgetSelector.vue?vue&type=template&id=15c4a450&"
import script from "./BudgetSelector.vue?vue&type=script&lang=js&"
export * from "./BudgetSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports